var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNovoClientPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8542 7.70833H8.89583M12.8542 10.875H8.89583M12.8542 4.54167H8.89583M6.125 1.375L6.125 15.625M5.175 1.375H11.825C13.1551 1.375 13.8202 1.375 14.3282 1.63386C14.7751 1.86156 15.1384 2.22489 15.3661 2.67177C15.625 3.17981 15.625 3.84488 15.625 5.175V11.825C15.625 13.1551 15.625 13.8202 15.3661 14.3282C15.1384 14.7751 14.7751 15.1384 14.3282 15.3661C13.8202 15.625 13.1551 15.625 11.825 15.625H5.175C3.84488 15.625 3.17981 15.625 2.67177 15.3661C2.22489 15.1384 1.86156 14.7751 1.63386 14.3282C1.375 13.8202 1.375 13.1551 1.375 11.825V5.175C1.375 3.84488 1.375 3.17981 1.63386 2.67177C1.86156 2.22489 2.22489 1.86156 2.67177 1.63386C3.17981 1.375 3.84488 1.375 5.175 1.375Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNovoClientPanel);
export default __webpack_public_path__ + "static/media/NovoClientPanel.7469970cda8a7ca2395b2e3882b6122d.svg";
export { ForwardRef as ReactComponent };